export default {
  core: {
    authorizationKey: process.env.REACT_APP_SPLIT_KEY,
    key: 'web-users',
  },
};

export const featureFlags = {
  publicProfilesCustomMetadata: 'public_profiles_custom_metadata',
  B2B_freemium_AOBF: 'B2B_freemium_AOBF',
  b2b_profile_updates: 'b2b_profile_updates',
  itj_notes: 'itj_notes',
  opensearch_migration: 'opensearch_migration',
  advisor_empty_state: 'advisor_empty_state',
  company_redesign: 'company_redesign',
  company_dual_account: 'company_dual_account',
  mobile_b2b_aobf: 'mobile_b2b_aobf',
};
